import { render, staticRenderFns } from "./CasesTree.vue?vue&type=template&id=5f11beec&scoped=true&"
import script from "./CasesTree.vue?vue&type=script&lang=ts&"
export * from "./CasesTree.vue?vue&type=script&lang=ts&"
import style0 from "./CasesTree.vue?vue&type=style&index=0&id=5f11beec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11beec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VTreeview})
